module.exports = __webpack_public_path__ + "img/13.5ed69192.jpg";